// extracted by mini-css-extract-plugin
module.exports = {"search":"wRHz5b8i","schoolList":"_2o9uQ6Lk","active":"_13KxengW","schoolName":"w3K56P9H","result":"_2aaqWhao"};